import React, { Component } from 'react';
import { Select } from "antd";
import { inject, observer } from "mobx-react";
import Area from "./Area";
import Income from "./Income";
import "./index.scss";

const Option = Select.Option;

@inject('store')
@observer
class index extends Component {
    state = {
        dateData: []
    }

    componentDidMount() {
        let date = Number(this.props.store.effectOcc.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });

        this.props.store.effectOcc.getData();
    }

    render() {
        const { date, onChangeDate } = this.props.store.effectOcc;
        return (
            <div className="performanceReview effect">
                <div className="first-title">
                    <div> 1.2 Meeting Room Occ 会议室需求统计</div>
                    <div className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={date}
                            onChange={(str) => {
                                onChangeDate(str);
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                    </div>
                </div>

                <Area />
                <Income />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/effect/1.2/index.js